<!--
 * @Description: echarts--饼图
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-14 14:24:47
-->
<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "@/utils/resize.js";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100vw"
    },
    height: {
      type: String,
      default: "300px"
    },
    chartData: {
      type: Object,
      default: _ => {}
    }
  },
  data() {
    return {
      chart: null,
      // data1:[],
      data1: [
        ['2020-11-11',3212.000,3212.000,3207.000,3218.000],['2020-11-11',3208.000,3210.000,3206.000,3216.000],['2020-11-11',3203.000,3212.000,3202.000,3212.000],['2020-11-11',3206.000,3203.000,3191.000,3206.000],['2020-11-11',3199.000,3208.000,3182.000,3209.000],['2020-11-10',3127.000,3129.000,3125.000,3136.000],['2020-11-10',3126.000,3128.000,3124.000,3131.000],['2020-11-10',3101.000,3115.000,3101.000,3122.000],['2020-11-10',3113.000,3101.000,3093.000,3114.000],['2020-11-10',3111.000,3110.000,3108.000,3112.000],['2020-11-10',3119.000,3110.000,3108.000,3121.000],['2020-11-10',3131.000,3120.000,3117.000,3138.000],['2020-11-09',3129.000,3127.000,3123.000,3130.000],['2020-11-09',3124.000,3126.000,3113.000,3128.000],['2020-11-09',3117.000,3104.000,3100.000,3120.000],['2020-11-09',3112.000,3117.000,3112.000,3122.000],['2020-11-09',3112.000,3113.000,3107.000,3114.000],['2020-11-09',3111.000,3115.000,3107.000,3119.000],['2020-11-09',3125.000,3112.000,3105.000,3131.000],['2020-11-06',3146.000,3126.000,3122.000,3149.000],['2020-11-06',3150.000,3147.000,3138.000,3158.000],['2020-11-06',3145.000,3151.000,3144.000,3152.000],['2020-11-06',3152.000,3144.000,3142.000,3152.000],['2020-11-06',3161.000,3158.000,3156.000,3161.000],['2020-11-06',3161.000,3162.000,3157.000,3165.000],['2020-11-06',3164.000,3161.000,3153.000,3165.000],['2020-11-05',3181.000,3168.000,3162.000,3181.000],['2020-11-05',3158.000,3179.000,3153.000,3185.000],['2020-11-05',3157.000,3160.000,3141.000,3163.000],['2020-11-05',3149.000,3156.000,3146.000,3157.000],['2020-11-05',3141.000,3150.000,3141.000,3153.000],['2020-11-05',3127.000,3141.000,3123.000,3143.000],['2020-11-05',3128.000,3124.000,3116.000,3131.000],['2020-11-04',3099.000,3097.000,3092.000,3109.000],['2020-11-04',3084.000,3094.000,3079.000,3098.000],['2020-11-04',3070.000,3072.000,3070.000,3074.000],['2020-11-04',3063.000,3071.000,3063.000,3076.000],['2020-11-04',3064.000,3063.000,3063.000,3066.000],['2020-11-04',3058.000,3064.000,3057.000,3066.000],['2020-11-04',3067.000,3060.000,3056.000,3077.000],['2020-11-03',3071.000,3069.000,3062.000,3072.000],['2020-11-03',3065.000,3069.000,3058.000,3072.000],['2020-11-03',3051.000,3051.000,3047.000,3055.000],['2020-11-03',3048.000,3052.000,3047.000,3054.000],['2020-11-03',3047.000,3049.000,3044.000,3052.000],['2020-11-03',3054.000,3048.000,3046.000,3057.000],['2020-11-03',3046.000,3054.000,3045.000,3058.000],['2020-11-03',3053.000,3053.000,3053.000,3053.000],['2020-11-02',3036.000,3053.000,3035.000,3057.000],['2020-11-02',3036.000,3036.000,3031.000,3041.000],['2020-11-02',3178.000,3175.000,3174.000,3183.000],['2020-11-02',3178.000,3180.000,3178.000,3186.000],['2020-11-02',3184.000,3181.000,3176.000,3184.000],['2020-11-02',3198.000,3182.000,3181.000,3198.000],['2020-11-02',3201.000,3200.000,3179.000,3211.000],['2020-10-30',3200.000,3199.000,3196.000,3205.000],['2020-10-30',3205.000,3203.000,3202.000,3212.000],['2020-10-30',3202.000,3191.000,3191.000,3204.000],['2020-10-30',3204.000,3201.000,3194.000,3208.000],['2020-10-30',3196.000,3212.000,3195.000,3213.000],['2020-10-30',3199.000,3197.000,3193.000,3199.000],['2020-10-30',3200.000,3198.000,3188.000,3204.000],['2020-10-29',3200.000,3201.000,3200.000,3207.000],['2020-10-29',3194.000,3199.000,3187.000,3206.000],['2020-10-29',3204.000,3201.000,3200.000,3206.000],['2020-10-29',3205.000,3205.000,3205.000,3210.000],['2020-10-29',3203.000,3204.000,3198.000,3204.000],['2020-10-29',3193.000,3203.000,3192.000,3209.000],['2020-10-29',3206.000,3193.000,3177.000,3207.000],['2020-10-29',3211.000,3211.000,3211.000,3211.000],['2020-10-28',3207.000,3212.000,3206.000,3219.000],['2020-10-28',3209.000,3209.000,3191.000,3215.000],['2020-10-28',3244.000,3248.000,3243.000,3254.000],['2020-10-28',3254.000,3245.000,3242.000,3256.000],['2020-10-28',3254.000,3253.000,3249.000,3255.000],['2020-10-28',3247.000,3254.000,3237.000,3256.000],['2020-10-28',3226.000,3245.000,3218.000,3247.000],['2020-10-27',3254.000,3245.000,3235.000,3256.000],['2020-10-27',3251.000,3252.000,3247.000,3265.000],['2020-10-27',3249.000,3244.000,3241.000,3258.000],['2020-10-27',3249.000,3253.000,3248.000,3257.000],['2020-10-27',3253.000,3249.000,3247.000,3253.000],['2020-10-27',3247.000,3253.000,3246.000,3257.000],['2020-10-27',3266.000,3250.000,3246.000,3268.000],['2020-10-26',3250.000,3261.000,3250.000,3269.000],['2020-10-26',3249.000,3247.000,3231.000,3249.000],['2020-10-26',3269.000,3250.000,3250.000,3271.000],['2020-10-26',3272.000,3268.000,3264.000,3272.000],['2020-10-26',3269.000,3271.000,3268.000,3273.000],['2020-10-26',3268.000,3269.000,3267.000,3273.000],['2020-10-26',3274.000,3269.000,3265.000,3282.000],['2020-10-24',3248.000,3248.000,3248.000,3248.000],['2020-10-23',3242.000,3235.000,3234.000,3252.000],['2020-10-23',3248.000,3242.000,3242.000,3259.000],['2020-10-23',3256.000,3233.000,3233.000,3258.000],['2020-10-23',3259.000,3256.000,3256.000,3265.000],['2020-10-23',3269.000,3259.000,3259.000,3271.000],['2020-10-23',3254.000,3267.000,3252.000,3269.000],['2020-10-23',3275.000,3255.000,3255.000,3275.000],['2020-10-23',3288.000,3288.000,3288.000,3288.000],['2020-10-22',3275.000,3288.000,3273.000,3288.000],['2020-10-22',3271.000,3276.000,3261.000,3276.000],['2020-10-22',3282.000,3272.000,3271.000,3282.000],['2020-10-22',3308.000,3284.000,3284.000,3308.000],['2020-10-22',3300.000,3304.000,3296.000,3309.000],['2020-10-22',3287.000,3297.000,3282.000,3297.000],['2020-10-22',3266.000,3289.000,3258.000,3302.000],['2020-10-21',3289.000,3281.000,3280.000,3292.000],['2020-10-21',3295.000,3289.000,3283.000,3297.000],['2020-10-21',3289.000,3284.000,3281.000,3294.000],['2020-10-21',3300.000,3289.000,3285.000,3305.000],['2020-10-21',3308.000,3307.000,3301.000,3314.000],['2020-10-21',3292.000,3308.000,3292.000,3310.000],['2020-10-21',3296.000,3291.000,3281.000,3300.000],['2020-10-20',3278.000,3279.000,3272.000,3294.000],['2020-10-20',3283.000,3279.000,3276.000,3316.000],['2020-10-20',3290.000,3282.000,3282.000,3308.000],['2020-10-20',3275.000,3289.000,3274.000,3291.000],['2020-10-20',3271.000,3276.000,3270.000,3279.000],['2020-10-20',3268.000,3272.000,3265.000,3275.000],['2020-10-20',3254.000,3267.000,3254.000,3272.000],['2020-10-19',3246.000,3254.000,3242.000,3257.000],['2020-10-19',3257.000,3249.000,3246.000,3272.000],['2020-10-19',3249.000,3259.000,3245.000,3259.000],['2020-10-19',3243.000,3247.000,3237.000,3247.000],['2020-10-19',3234.000,3247.000,3234.000,3249.000],['2020-10-19',3242.000,3239.000,3234.000,3245.000],['2020-10-19',3264.000,3245.000,3228.000,3266.000],['2020-10-17',3264.000,3264.000,3264.000,3264.000],['2020-10-16',3265.000,3263.000,3258.000,3271.000],['2020-10-16',3280.000,3272.000,3270.000,3311.000],['2020-10-16',3261.000,3274.000,3261.000,3278.000],['2020-10-16',3263.000,3263.000,3259.000,3270.000],['2020-10-16',3256.000,3264.000,3254.000,3264.000],['2020-10-16',3258.000,3257.000,3253.000,3260.000],['2020-10-16',3261.000,3258.000,3254.000,3274.000],['2020-10-15',3219.000,3251.000,3219.000,3251.000],['2020-10-15',3196.000,3221.000,3190.000,3223.000],['2020-10-15',3229.000,3231.000,3216.000,3231.000],['2020-10-15',3236.000,3234.000,3231.000,3238.000],['2020-10-15',3236.000,3238.000,3234.000,3240.000],['2020-10-15',3244.000,3237.000,3237.000,3245.000],['2020-10-15',3248.000,3245.000,3233.000,3248.000],['2020-10-14',3242.000,3236.000,3232.000,3247.000],['2020-10-14',3238.000,3242.000,3231.000,3243.000],['2020-10-14',3226.000,3232.000,3224.000,3234.000],['2020-10-14',3228.000,3225.000,3222.000,3229.000],['2020-10-14',3218.000,3226.000,3214.000,3226.000],['2020-10-14',3228.000,3218.000,3212.000,3231.000],['2020-10-14',3245.000,3230.000,3227.000,3250.000],['2020-10-13',3235.000,3239.000,3231.000,3242.000],['2020-10-13',3227.000,3236.000,3227.000,3240.000],['2020-10-13',3240.000,3239.000,3224.000,3240.000],['2020-10-13',3236.000,3240.000,3236.000,3246.000],['2020-10-13',3233.000,3233.000,3231.000,3239.000],['2020-10-13',3236.000,3232.000,3230.000,3237.000],['2020-10-13',3230.000,3236.000,3220.000,3238.000],['2020-10-13',3233.000,3233.000,3233.000,3233.000],['2020-10-12',3255.000,3231.000,3224.000,3255.000],['2020-10-12',3276.000,3257.000,3255.000,3277.000],['2020-10-12',3290.000,3286.000,3286.000,3301.000],['2020-10-12',3273.000,3292.000,3273.000,3297.000],['2020-10-12',3267.000,3281.000,3266.000,3281.000],['2020-10-12',3281.000,3266.000,3266.000,3281.000],['2020-10-12',3251.000,3285.000,3251.000,3286.000],['2020-10-09',3258.000,3263.000,3255.000,3263.000],['2020-10-09',3261.000,3258.000,3243.000,3265.000],['2020-10-09',3247.000,3239.000,3238.000,3251.000],['2020-10-09',3245.000,3245.000,3241.000,3247.000],['2020-10-09',3250.000,3247.000,3242.000,3251.000],['2020-10-09',3245.000,3250.000,3244.000,3258.000],['2020-10-09',3195.000,3241.000,3195.000,3251.000],['2020-09-30',3089.000,3087.000,3082.000,3094.000],['2020-09-30',3084.000,3085.000,3075.000,3085.000],['2020-09-30',3084.000,3086.000,3082.000,3087.000],['2020-09-30',3086.000,3085.000,3084.000,3089.000],['2020-09-30',3072.000,3087.000,3068.000,3095.000],['2020-09-29',3070.000,3072.000,3068.000,3077.000],['2020-09-29',3064.000,3071.000,3053.000,3074.000],['2020-09-29',3070.000,3073.000,3070.000,3077.000],['2020-09-29',3070.000,3069.000,3064.000,3074.000],['2020-09-29',3074.000,3072.000,3069.000,3076.000],['2020-09-29',3074.000,3074.000,3069.000,3075.000],['2020-09-29',3083.000,3074.000,3071.000,3084.000],['2020-09-28',3082.000,3078.000,3072.000,3083.000],['2020-09-28',3097.000,3082.000,3082.000,3100.000],['2020-09-28',3091.000,3093.000,3090.000,3103.000],['2020-09-28',3085.000,3093.000,3079.000,3095.000],['2020-09-28',3105.000,3079.000,3077.000,3106.000],['2020-09-28',3104.000,3106.000,3102.000,3111.000],['2020-09-28',3090.000,3103.000,3087.000,3109.000],['2020-09-25',3079.000,3094.000,3078.000,3104.000],
      ]
    };
  },
  watch: {
    data0() {
      return this.splitData(this.data1);
      // return this.data1
    },
    chartData: {
      deep: true,
      handler(val) {
        this.initChart(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
   created() {
    this.newsList();
  },
  methods: {
     newsList: function () {
      this.$axios({
        method: "get",
        // data: qs.stringify({
        //   id: id,
        // }),
        url: "/index.php/rczp",
        header: {
          "Content-Type": "application/x-www-form-urlencoded", 
        },
      }).then((res) => {
        // this.information = res.data.data;
       
     
      
       
      });
    },
    calculateMA(dayCount) {
      let data0 = this.splitData(this.data1); 
      var result = [];
      for (var i = 0, len = data0.values.length; i < len; i++) {
        if (i < dayCount) {
          result.push("-");
          continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data0.values[i - j][1];
        }
        result.push(sum / dayCount);
      }
      return result;
    },
    splitData(rawData) {
      var categoryData = [];
      var values = [];
      for (var i = 0; i < rawData.length; i++) {
        categoryData.push(rawData[i].splice(0, 1)[0]);
        values.push(rawData[i]);
      }
      return {
        categoryData: categoryData,
        values: values
      };
    },
    initChart(val) {
      this.chart = echarts.init(this.$el, "macarons"); 
      let data0 = this.splitData(this.data1);
      this.chart.setOption({
        title: {
          text: "长航凤凰",
          left: '23'
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          data: [  "涨幅", "现价", "涨跌"]
        },
        grid: {
          left: "10%",
          right: "10%",
          bottom: "15%"
        },
        xAxis: {
          type: "category",
          data: data0.categoryData,
          scale: true,
          boundaryGap: false,
          axisLine: { onZero: false },
          splitLine: { show: false },
          splitNumber: 20,
          min: "dataMin",
          max: "dataMax"
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true
          }
        },
        dataZoom: [
          {
            type: "inside",
            start: 50,
            end: 100
          },
          {
            show: true,
            type: "slider",
            top: "90%",
            start: 50,
            end: 100
          }
        ],
        series: [
        //   {
        //     name: "日K",
        //     type: "candlestick",
        //     data: data0.values,
        //     itemStyle: {
        //       color: "#ec0000",
        //       color0: "#8A0000",
        //       borderColor: "#00da3c",
        //       borderColor0: "#008F28"
        //     },
        //     markPoint: {
        //       label: {
        //         normal: {
        //           formatter: function(param) {
        //             return param != null ? Math.round(param.value) : "";
        //           }
        //         }
        //       },
        //       data: [
        //         {
        //           name: "XX标点",
        //           coord: ["2013/5/31", 2300],
        //           value: 2300,
        //           itemStyle: {
        //             color: "rgb(41,60,85)"
        //           }
        //         },
        //         {
        //           name: "highest value",
        //           type: "max",
        //           valueDim: "highest"
        //         },
        //         {
        //           name: "lowest value",
        //           type: "min",
        //           valueDim: "lowest"
        //         },
        //         {
        //           name: "average value on close",
        //           type: "average",
        //           valueDim: "close"
        //         }
        //       ],
        //       tooltip: {
        //         formatter: function(param) {
        //           return param.name + "<br>" + (param.data.coord || "");
        //         }
        //       }
        //     },
        //     markLine: {
        //       symbol: ["none", "none"],
        //       data: [
        //         [
        //           {
        //             name: "from lowest to highest",
        //             type: "min",
        //             valueDim: "lowest",
        //             symbol: "circle",
        //             symbolSize: 10,
        //             label: {
        //               show: false
        //             },
        //             emphasis: {
        //               label: {
        //                 show: false
        //               }
        //             }
        //           },
        //           {
        //             type: "max",
        //             valueDim: "highest",
        //             symbol: "circle",
        //             symbolSize: 10,
        //             label: {
        //               show: false
        //             },
        //             emphasis: {
        //               label: {
        //                 show: false
        //               }
        //             }
        //           }
        //         ],
        //         {
        //           name: "min line on close",
        //           type: "min",
        //           valueDim: "close"
        //         },
        //         {
        //           name: "max line on close",
        //           type: "max",
        //           valueDim: "close"
        //         }
        //       ]
        //     }
        //   },
          {
            name: "涨幅",
            type: "line",
            data: this.calculateMA(5),
            smooth: true,
            lineStyle: {
              opacity: 0.5
            }
          },
          {
            name: "现价",
            type: "line",
            data: this.calculateMA(10),
            smooth: true,
            lineStyle: {
              opacity: 0.5
            }
          },
          {
            name: "涨跌",
            type: "line",
            data: this.calculateMA(20),
            smooth: true,
            lineStyle: {
              opacity: 0.5
            }
          }
        //   ,
        //   {
        //     name: "MA30",
        //     type: "line",
        //     data: this.calculateMA(30),
        //     smooth: true,
        //     lineStyle: {
        //       opacity: 0.5
        //     }
        //   }
        ]
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/haed/pieChart.vue